import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MarkNoteReadSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MarkNoteReadSVG;
